
        var i18n = require('cadenza/utils/i18n/i18n');
        module.exports = (function () {
          var messages = {"de":{"action.label":"KML-Datei","dialog.title":"KML-Datei exportieren"},"en":{"action.label":"KML file","dialog.title":"Export KML file"}};
          return function () {
            return i18n.loaderI18n.apply(messages[window.Disy.language], arguments);
          };
        })();